import { useEffect, useRef } from 'react'
import sanitizeHtml from 'sanitize-html'

const AgreementText = ({ agreementContent }: { agreementContent?: string }) => {
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (divRef.current && agreementContent) {
      divRef.current.innerHTML = sanitizeHtml(agreementContent)
    }
  }, [agreementContent])

  return <div ref={divRef} />
}

export default AgreementText
